<template>
	<v-container>
        <AppLoading v-if="isPending" />
        <div v-else>
            <div class="text-center">
                <v-icon
                    class="mb-4"
                    :color="error ? 'error' : 'success'"
                    x-large
                >
                 {{
                    error 
                        ? 'mdi-alert-circle-outline'
                        : 'mdi-check-circle-outline' 
                 }}
                </v-icon>
                <div class="text-h6">
                    {{ error ? getErrorMessage(error) : 'Certificado solicitado, aguarde aprovação da loja visitada' }}
                </div>
            </div>
        </div>
    </v-container>
</template>

<script setup lang="ts">
import AppLoading from '@/components/ui/AppLoading.vue';
import { getErrorMessage } from '@/helpers/error-helpers';
import CertificadoService from '@/services/CertificadoService';
import { useMutation } from '@tanstack/vue-query';
import { CertificadoInput } from '@/../common/types/certificado/CertificadoInput';

const { token } = defineProps<{
    token: string;
}>()

const { data, isPending, error, mutate } = useMutation({
    mutationFn: (params: CertificadoInput) => CertificadoService.post(params)
})

mutate({ token })

</script>
